const folderList = [
  {id: 121, name: 'All', alias: 'all', icon: 'group'},
  {id: 122, name: 'Frequent', alias: 'frequent', icon: 'autorenew'},
  {id: 124, name: 'Starred', alias: 'starred', icon: 'starBorder'},
];
export default folderList;
